import { render, staticRenderFns } from "./MonAlokasi.vue?vue&type=template&id=4fe807da"
import script from "./MonAlokasi.vue?vue&type=script&lang=js"
export * from "./MonAlokasi.vue?vue&type=script&lang=js"
import style0 from "./MonAlokasi.vue?vue&type=style&index=0&id=4fe807da&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports